






























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { StepMixin, StepStoreMixin } from '@mixin';
import { StringHelper } from '@fruitpackage/helpers';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            store: {
                amount: null,
            },
            proxyAmount: null,
        };
    },

    mixins: [
        StepMixin,
        StepStoreMixin,
    ],

    created() {
        this.proxyAmount = this.store.amount;
    },

    mounted() {
        this.inputEl = this.$refs.input.$el.querySelector('input');

        this.inputEl.addEventListener('focus', () => {
            this.errorData = null;
        });
    },

    methods: {
        async onNext() {
            return this._store(this.store).then(() => {
                return true;
            })
        },
    },

    watch: {
        proxyAmount() {
            if (this.current.organisation.community && parseInt(this.proxyAmount) > 3000) {
                this.inputEl.value = '3000';
                this.proxyAmount = '3000';
                this.errorData = 'Voor een bewonersinitiatief kan max. 3000 euro worden aangevraagd.';
                this.inputEl.blur();
            }

            this.store.amount = this.proxyAmount.replace(/[^\d]/g, '');
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ProjectBedrag extends Vue {}

